define('widgets/inputs/phoneNumber/viewmodel',['knockout', 'widgets/inputs/AbstractInputWidget'], function (ko, AbstractInputWidget) {

    /**
     * Usage:
     *
     *      <div data-bind="inputs.phoneNumber: settings"></div>
     *
     * Settings:
     *      {core/FormFields.phoneNumberField} field
     *      {Observable String} label
     *      {Boolean} autoFocus (Default: false)
     */
    function PhoneNumberInputWidget () {
        AbstractInputWidget.call(this);

        this.bufferedPrefix = ko.observable('');

        this.onPrefixBlur = function () {
            this.bufferedPrefix('');
        }.bind(this);

        this.ignoreNonNumericKeys = function (o, e) {
            if (isNaN(String.fromCharCode(e.keyCode))) {
                e.originalEvent.preventDefault();
                return false;
            }
            return true;
        }.bind(this);
    }

    PhoneNumberInputWidget.prototype = Object.create(AbstractInputWidget.prototype);

    PhoneNumberInputWidget.prototype.activate = function (settings) {

        var self = this;

        AbstractInputWidget.prototype.activate.call(this, settings);

        // @todo dhowlett The durandal fix means widget
        // composition is dependent on values read during activate
        if (!settings.field.prefix.value.peek()) {
            settings.field.prefix.value (settings.field.suggestedPrefix.peek());
        }

        self.subscriptions.push(self.bufferedPrefix.subscribe(function (bufferedPrefix) {
            if (bufferedPrefix) {
                self.field.prefix.value(bufferedPrefix);
            }
        }));

    };

    return PhoneNumberInputWidget;

});

